import { diInject } from '@di/di';
import { EventEmitter } from '@studio/utils/event-emitter';
export class TimelineApi extends EventEmitter {
    get duration() {
        return this._animator.duration;
    }
    get currentTime() {
        return this._animator.time;
    }
    get loop() {
        return this._animator.loop;
    }
    get loops() {
        return this._animator.creative.loops;
    }
    get isPlaying() {
        return this._animator.isPlaying;
    }
    constructor() {
        super();
        this._animator = diInject(3 /* Token.ANIMATOR */);
        this._animator.on('loop', (loop) => this.emit('loop', loop));
        this._animator.on('pause', (time) => this.emit('pause', time));
        this._animator.on('play', (time) => this.emit('play', time));
        this._animator.on('stop', (time) => this.emit('stop', time));
        this._animator.on('restart', (time) => this.emit('restart', time));
        this._animator.on('replay', (time) => this.emit('replay', time));
        this._animator.on('seek', (time) => this.emit('seek', time));
        this._animator.on('tick', (time) => this.emit('tick', time));
    }
    play() {
        this._animator.addToQueueFromWidget(this._animator.play);
        return this;
    }
    pause() {
        this._animator.addToQueue(this._animator.pause);
        return this;
    }
    restart() {
        this._animator.restart();
        return this;
    }
    replay() {
        this._animator.replay();
        return this;
    }
    nextLoop(replay, offset) {
        if (offset) {
            offset = Math.abs(offset);
        }
        this._animator.addToQueue(this._animator.next, [replay, offset]);
        return this;
    }
    previousLoop(replay, offset, exceedLimit) {
        if (offset) {
            offset = Math.abs(offset);
        }
        this._animator.addToQueue(this._animator.prev, [replay, offset, exceedLimit]);
        return this;
    }
    seek(time) {
        if (typeof time !== 'number') {
            console.error('Seek requires 1 argument with the type of number.');
            return this;
        }
        this._animator.addToQueue(this._animator.seek, [time]);
        return this;
    }
    setLoop(loop) {
        if (typeof loop !== 'number') {
            console.error('setloop requires 1 argument with the type of number.');
            return this;
        }
        this._animator.addToQueue(this._animator.setLoop, [loop]);
        return this;
    }
    suspendEvents() {
        this.skipEmission = true;
    }
    resumeEvents() {
        this.skipEmission = false;
    }
    destroy() {
        this.clearEvents();
    }
}
